import { timestampToMillis } from "./dataAdapters";
import { normalizeEventRecord } from "./eventViewModel";

export const COMMUNITY_FEED_FILTERS = [
  { value: "all", label: "All" },
  { value: "events", label: "Events" },
  { value: "updates", label: "Community updates" },
  { value: "locations", label: "Locations" },
];

const UPLOAD_KIND_LABELS = {
  "community-update": "Community update",
  opportunity: "Opportunity",
  job: "Job",
  volunteering: "Volunteering",
  consultation: "Consultation",
  "local-news": "Local news",
  activity: "Activity",
  offer: "Offer",
  announcement: "Announcement",
  location: "Location",
};

function normalizeUploadKind(type) {
  const value = String(type || "community-update").trim().toLowerCase();
  if (value === "event") return "community-update";
  return UPLOAD_KIND_LABELS[value] ? value : "community-update";
}

export function normalizeCommunityUpload(idOrUpload, data = {}) {
  const source =
    typeof idOrUpload === "object" && idOrUpload !== null
      ? idOrUpload
      : { ...data, id: idOrUpload || data.id };
  const sourceId = source.sourceId || source.id || "";
  const kind = normalizeUploadKind(source.type || source.kind || source.category);
  const wasLegacyEventDocument = String(source.type || "").toLowerCase() === "event";

  return {
    id: `upload:${sourceId}`,
    sourceId,
    sourceCollection: "uploads",
    kind,
    typeLabel: wasLegacyEventDocument
      ? "Event document"
      : UPLOAD_KIND_LABELS[kind],
    title: source.title || source.name || "Community update",
    description: source.description || source.summary || "",
    fileUrl: source.fileUrl || source.url || "",
    createdAt: source.createdAt || source.approvedAt || source.publishedAt || "",
    source,
  };
}

export function normalizeCommunityEvent(event) {
  const normalized = normalizeEventRecord(event);
  const sourceId = normalized.sourceId || normalized.id || "";

  return {
    id: `event:${sourceId}`,
    sourceId,
    sourceCollection: "events",
    kind: "event",
    typeLabel: "Event",
    title: normalized.title,
    description: normalized.description,
    createdAt:
      normalized.createdAt ||
      normalized.approvedAt ||
      normalized.eventDate ||
      normalized.startDate ||
      "",
    event: normalized,
  };
}

export function compareCommunityFeedDesc(a, b) {
  const dateDifference = timestampToMillis(b.createdAt) - timestampToMillis(a.createdAt);
  return dateDifference || String(a.title || "").localeCompare(String(b.title || ""));
}

export function buildCommunityFeed({ events = [], uploads = [] } = {}) {
  return [
    ...events.map(normalizeCommunityEvent),
    ...uploads.map(normalizeCommunityUpload),
  ].sort(compareCommunityFeedDesc);
}

export function filterCommunityFeed(feed, filter) {
  if (filter === "events") return feed.filter((item) => item.kind === "event");
  if (filter === "locations") return feed.filter((item) => item.kind === "location");
  if (filter === "updates") {
    return feed.filter((item) => !["event", "location"].includes(item.kind));
  }
  return feed;
}

export function getAvailableCommunityFeedFilters(feed) {
  return COMMUNITY_FEED_FILTERS.filter(({ value }) => {
    if (value === "all") return true;
    return filterCommunityFeed(feed, value).length > 0;
  });
}
